import React from "react";
import PropTypes from "prop-types";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Fieldset from "../common/Fieldset";
import Row from "../common/Row";

const ContactPersoonForm = ({
	contactpersoon,
	disabled,
	errors,
	title,
	tooltip,
	tooltipWindowWidth,
	tooltipWindowAlignRight,
	listOfAanvragers,
	onChange,
	validationMessageType }) => {

	const sharedProps = {
		disabled,
		size: 6,
		onChange
	};


	const aanvrager = (listOfAanvragers.length > 1
		? (<SelectInput
			{...sharedProps}
			name="accountId"
			label="Aanvrager"
			defaultItem="Kies een aanvrager"
			value={contactpersoon.accountId.toString()}
			items={listOfAanvragers}
			validationMessage={errors ? errors.accountId : ''}
			validationMessageType={validationMessageType} />)
		: listOfAanvragers.length ? <TextInput
			size={6}
			onChange={onChange}
			disabled
			name="accountId"
			label="Aanvrager"
			value={listOfAanvragers[0].label}
			validationMessage={errors ? errors.accountId : ''}
			validationMessageType={validationMessageType} /> : '');

	return (
		<Fieldset title={title} tooltip={tooltip} tooltipWindowWidth={tooltipWindowWidth} tooltipWindowAlignRight={tooltipWindowAlignRight}>
			<Row>
				<TextInput
					{...sharedProps}
					label="Voornaam"
					name="voornaam"
					value={contactpersoon.voornaam}
					validationMessage={errors ? errors.voornaam : ''}
					maxLength={100}
					validationMessageType={validationMessageType} />
				<TextInput
					{...sharedProps}
					label="Naam"
					name="naam"
					value={contactpersoon.naam}
					validationMessage={errors ? errors.naam : ''}
					maxLength={100}
					validationMessageType={validationMessageType} />
			</Row>
			<Row>
				<TextInput
					{...sharedProps}
					label="E-mail"
					name="email"
					value={contactpersoon.email}
					validationMessage={errors ? errors.email : ''}
					maxLength={100}
					validationMessageType={validationMessageType} />
				<TextInput
					{...sharedProps}
					label="Telefoon / GSM"
					name="tel"
					value={contactpersoon.tel}
					validationMessage={errors ? errors.tel : ''}
					validationMessageType={validationMessageType} />
			</Row>
			<Row>
				<TextInput
					{...sharedProps}
					label="Functie"
					name="functie"
					value={contactpersoon.functie}
					validationMessage={errors ? errors.functie : ''}
					maxLength={100}
					validationMessageType={validationMessageType} />
				{aanvrager}
			</Row>
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
ContactPersoonForm.propTypes = {
	contactpersoon: PropTypes.object.isRequired,
	title: PropTypes.string.isRequired,
	listOfAanvragers: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default ContactPersoonForm;
